// extracted by mini-css-extract-plugin
module.exports = {"export":"ExternalLinkIcon-module--export--3gleA"};